// constants
import { GOALS_SERVICE, GOALS_IMPACT } from 'modules/customers/customer-edit/constants';


const StyleProfileItem = ({ field, options }) => {

    if (!field || !field.length) {
        return null;
    }

    const data = (typeof (field) === 'string' ? field?.split(',') : field) || [];

    const getClass = (option) => {
        return data.toString().toLowerCase().includes(option.toLowerCase()) ? 'is-large is-primary' : 'is-light';
    }

    return (
        <>
            {options.map((option) => (
                <span key={option} className={`tag ${getClass(option)} m-2`}>{option}</span>
            ))}
        </>
    );
};

const Goals = ({ customer }) => {
    if (!customer.goals) {
        return null;
    }

    return (
        <>
            <h1 className="title">Goals</h1>

            <div className="block">
                <h1 className="subtitle">"I want to reduce:"</h1>
                <StyleProfileItem field={customer.goals.impact} options={GOALS_IMPACT} />
            </div>

            <div className="block">
                <h1 className="subtitle">"I am waiting for:"</h1>
                <StyleProfileItem field={customer.goals.service} options={GOALS_SERVICE} />
            </div>

        </>
    );
}

export { Goals };
